/**
 * End Pier 1 — display names 1–30 for Strain(1)–Strain(30).
 * Keys (left) stay as API IDs; only edit values if you want different labels.
 */
import { buildNumberedStrainLabels } from '../../utils/sensorDisplayName';

export const SENSOR_LABELS = buildNumberedStrainLabels(30);
